import React, { ReactNode }  from "react";
import { Container } from "./styles";

interface Props{
    children?: ReactNode;
}

const Card = (props:Props) => {
  return (
  <Container
    initial={{
      boxShadow: "none"
    }}
    animate={{
      boxShadow: "-1px 15px 55px -21px rgba(255, 202, 174, 1)",
    }}
    transition={{
      delay: 2,
      duration: 1
    }}
  >
      {props.children}
  </Container>);
}

export default Card;